import * as React from 'react';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import PopEditElement from './PopEditElement';

const Upload = ({ element, elementStyle, updateElement }) => {
  const { formSettings, settings, className = "" } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <PopEditElement className={className} element={element} />
    </FormItem>
  );
};

export default Upload;
